<template lang="pug">
#print-layout
  router-view
</template>

<script>
export default {
  name: 'PrintLayout',
  mounted() {
    // Preparar para impresión
    document.body.classList.add('print-mode');
  },
  beforeUnmount() {
    document.body.classList.remove('print-mode');
  },
};
</script>
